import React from "react";
import BackButton from "../../main/BackButton";
import Video from "../../main/Video";

const Collection10Video = () => {
  return (
    <>
      <BackButton url="/allvideos" />
      <Video
        url={`https://yuriy-dmytrash19.wistia.com/medias/4i20ce2noh`}
        maxHeight="80%"
      />
    </>
  );
};

export default Collection10Video;
